import React from 'react';
import '../styles/navdrawer.css';
import { Paper, Typography, Button, Toolbar } from '@material-ui/core';

const rootClass = "navdrawer root";
const screenDarkenerClass = "navdrawer screendarkener";
const drawerClass = "navdrawer drawer";
const itemClass = "navdrawer item";
const itemTitleClass = "navdrawer itemtitle";
const subItemClass = "navdrawer subitem"
const fadeOutAdditum = " fadeout";

class NavDrawer extends React.Component {

    constructor(...args) {
        super(...args);
        this.oldOpen = false;
        this.timeout = null;
        this.fu = this.fu.bind(this);
    }

    render() {
        if (this.oldOpen !== this.props.isopen && this.props.isopen) {
            if (this.timeout !== null) {
                clearTimeout(this.timeout);
            }
        }
        let j = this.oldOpen !== this.props.isopen && !this.props.isopen;
        if (this.props.isopen || this.oldOpen) {
            if (j) {
                this.timeout = setTimeout(this.fu, 999);
            }
            this.oldOpen = this.props.isopen;
            return (
                <div className={rootClass}>
                    <div className={screenDarkenerClass + (j ? fadeOutAdditum : "")} onClick={this.props.close}></div>
                    <Paper square className={drawerClass + (j ? fadeOutAdditum : "")} elevation={0}>
                        <Toolbar />
                        <Paper square className={itemClass} elevation={3}>
                            <Button className={itemTitleClass} href="/list"><Typography variant="h4">Klasse</Typography></Button>
                            <Button className={subItemClass} href="/klasse/5"><Typography variant="h5">5</Typography></Button>
                            <Button className={subItemClass} href="/klasse/6"><Typography variant="h5">6</Typography></Button>
                            <Button className={subItemClass} href="/klasse/7"><Typography variant="h5">7</Typography></Button>
                            <Button className={subItemClass} href="/klasse/8"><Typography variant="h5">8</Typography></Button>
                            <Button className={subItemClass} href="/klasse/9"><Typography variant="h5">9</Typography></Button>
                            <Button className={subItemClass} href="/klasse/10"><Typography variant="h5">10</Typography></Button>
                        </Paper>
                        <Paper square className={itemClass} elevation={3}>
                            <Button className={itemTitleClass} href="/download"><Typography variant="h4">Herunterladen</Typography></Button>
                        </Paper>
                    </Paper>
                </div>
            );
        } else {
            return (<div></div>);
        }
    }

    fu() {
        this.forceUpdate();
    }
}

export default NavDrawer;
